<template>
  <div>
    <div v-if="loading" class="text-gray-500 p-4 flex items-center gap-2">
      <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
      Loading...
    </div>
    <div v-else-if="error" class="text-red-700 p-4 bg-red-50 rounded-xl">{{ error }}</div>
    <div v-else class="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div class="divide-y divide-gray-100 max-h-[calc(100vh-280px)] overflow-y-auto">
        <PracticeListItem
          v-for="practice in practices"
          :key="practice.PAC_ID"
          :practice="practice"
          :selected="selectedPacId === practice.PAC_ID"
          @click="$emit('select', practice)"
        >
          <template #actions>
            <button v-if="practice.TIN_ID" @click.stop="$emit('toggle-aco-builder', practice)" :class="['text-xs px-2 py-1 rounded-full transition-all duration-200', isInRoster(practice.TIN_ID) ? 'bg-primary-600/15 text-primary-600 hover:bg-primary-600/25' : 'bg-gray-50 text-gray-500 hover:bg-gray-100']" :title="isInRoster(practice.TIN_ID) ? 'Remove from ACO Builder' : 'Add to ACO Builder'">
              {{ isInRoster(practice.TIN_ID) ? '✓' : '+' }}
            </button>
          </template>
        </PracticeListItem>
        <div v-if="practices.length === 0" class="p-8 text-center text-gray-500 text-sm">No practices found</div>
      </div>
      <div class="border-t border-gray-100 px-4 py-2.5 flex justify-between items-center text-xs text-gray-500">
        <span class="font-mono">{{ pagination.offset + 1 }}-{{ pagination.offset + practices.length }} of {{ formatNumber(pagination.total) }}</span>
        <div class="flex gap-1.5">
          <button @click="$emit('prev-page')" :disabled="pagination.offset === 0" class="px-3 py-1 border border-gray-200 rounded-lg disabled:opacity-40 hover:bg-gray-50 font-medium transition-colors">Prev</button>
          <button @click="$emit('next-page')" :disabled="pagination.offset + pagination.limit >= pagination.total" class="px-3 py-1 border border-gray-200 rounded-lg disabled:opacity-40 hover:bg-gray-50 font-medium transition-colors">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeListItem from '../PracticeListItem.vue'

export default {
  name: 'PracticeList',
  components: { PracticeListItem },
  props: {
    practices: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
    pagination: { type: Object, required: true },
    selectedPacId: { type: String, default: null },
    acoBuilderRoster: { type: Array, default: () => [] },
  },
  emits: ['select', 'toggle-aco-builder', 'prev-page', 'next-page'],
  methods: {
    isInRoster(tinId) {
      return this.acoBuilderRoster.some(item => item.tinId === tinId)
    },
    formatNumber(num) {
      if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
      if (num >= 1000) return (num / 1000).toFixed(1) + 'K'
      return num?.toLocaleString() || '0'
    },
  },
}
</script>
